module.exports = "/account/components/availableInSubscriptionComponent-63dbdc.html";